import store from "../../state/store";
import actionCreators from "../../state/actions";

const globalState = {
  store,
  dispatch: (...args) => store.dispatch(...args),
  getState: (...args) => store.getState(...args),
  subscribe: (...args) => store.subscribe(...args),
  actions: actionCreators
};

export default globalState;
